import {i18n} from '@online-offer/i18n';
import {Separator} from 'platform/components';
import {Box, Heading, HStack, Icon, Link, Show, Text, VStack} from 'platform/foundation';
import {formatPhoneNumber} from 'platform/locale';
import {css} from 'styled-components';

import {CardOo} from '../../components/CardOo/CardOo';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {placeholderFallback} from '../../utils/placeholderFallback';

export function SellerCardPrint() {
  const {owner} = useGetOnlineOfferData();

  if (!owner) {
    return null;
  }

  const ownerName = [owner.firstName, owner.lastName].filter(Boolean).join(' ');

  return (
    <div
      css={css`
        page-break-inside: avoid;
      `}
    >
      <Box width="100%" overflow="hidden" paddingHorizontal={10} paddingVertical={5}>
        <CardOo backgroundColor="semantic.bg.subtle">
          <VStack width="100%">
            <HStack width="100%" spacing={5}>
              <VStack width="100%" spacing={2}>
                <VStack width="100%" spacing={1}>
                  <Heading size={4}>{placeholderFallback(ownerName)}</Heading>
                  <Text size="xSmall" color="secondary">
                    {i18n.t('sellerCard.seller')}
                  </Text>
                </VStack>
                <Separator spacing={0} />
                <Show when={owner.phoneNumber}>
                  <HStack width="100%" spacing={2} align="center">
                    <Icon size={5} value="social/telephone" />
                    <Text size="xSmall">
                      {owner.phoneNumber &&
                        formatPhoneNumber(
                          `${owner.phoneNumber.prefix + owner.phoneNumber.number}`,
                          owner.phoneNumber.countryCode
                        )}
                    </Text>
                  </HStack>
                </Show>
                <HStack width="100%" spacing={2} align="center">
                  <Icon size={5} value="social/email" />
                  <Link size="xSmall" href={`mailto:${owner.email}`} title={owner.email} />
                </HStack>
              </VStack>
            </HStack>
          </VStack>
        </CardOo>
      </Box>
    </div>
  );
}
